import React, { useContext } from "react";
import Footer from "~/assets/js/components/Footer";
import { CheckoutContext } from "../CheckoutProvider";

const CheckoutFooter = () => {
    const { state } = useContext(CheckoutContext);
    return <Footer customCondition={state.page === "cart"} />;
};

export default CheckoutFooter;
